'use client';

import { JSX } from 'react';

import { Button, Text } from '@videoblocks/design-system';

const UpgradeSupport = (): JSX.Element => {
    const handleSupportClick = () => {
        if (typeof window !== 'undefined' && window.Intercom) {
            window.Intercom('show');
        }
    };

    return (
        <div className="bg-white p-8 rounded-lg shadow-sm border border-gray-200 max-w-3xl mx-auto">
            <Text fontSize="xl" fontWeight="semibold" asChild className="mb-8">
                <h2>We&apos;re here to help you upgrade</h2>
            </Text>
            <Text className="mb-8 text-gray-900" fontWeight="regular">
                Please reach out to our Customer Support Team at{' '}
                <button
                    type="button"
                    className="text-blue-700 hover:underline font-semibold"
                    onClick={handleSupportClick}
                    aria-label="Open chat with customer support (opens Intercom chat window)"
                    title="Click to open chat with customer support"
                    role="button"
                >
                    support@storyblocks.com
                </button>{' '}
                to upgrade your plan.
            </Text>
            <Button variant="primary" className="rounded-sm px-6 ml-auto" onClick={handleSupportClick}>
                Contact Customer Service
            </Button>
        </div>
    );
};

export default UpgradeSupport;
